import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {adminGetVendor, adminUpdateVendor} from "../../../services/api/admin";
import SwitchButton from "../../../components/Input/Switch";
import {AdminTable} from "../../../components/Admin/Common/AdminTable";

const CDN = process.env.REACT_APP_RESIZABLE;

const AdminVendorDetail = () => {
    const [vendorsFetched, setVendorsFetched] = useState(false);
    const [vendorsData, setVendorsData] = useState([]);
    const {id} = useParams();

    const fetchVendorData = async () => {
        if (!vendorsData.length && !vendorsFetched)
            try {
                const data = await adminGetVendor(id);
                const transformedData = {
                    id: {data: data.id, classes: ""},
                    name: {
                        data: data.name,
                        classes: ""
                    },
                    slug: {
                        data: data.slug,
                        classes: ""
                    },
                    logo: {
                        data: <img alt={data.slug} width={50} height={50} style={{objectFit: "contain"}}
                                   src={`${CDN}/${data.logo}`}/>,
                        classes: ""
                    },

                    has_dashboard: {
                        data: <SwitchButton
                            checked={data.has_dashboard}
                            onChange={async (checked) => {
                                await adminUpdateVendor(data.id, checked);
                                await fetchVendorData().catch(console.error);
                            }}
                        />,
                        classes: ""
                    },

                };
                setVendorsFetched(true);
                setVendorsData([transformedData]);


            } catch (e) {
                console.error('Error fetching conversations:', e);
            }
    }

    React.useEffect(() => {
            fetchVendorData().catch(console.error);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);


    const headers = [
        {data: 'ID', classes: ""},
        {data: 'Name', classes: ""},
        {data: 'Slug', classes: ""},
        {data: 'Logo', classes: ""},
        {data: 'Has Dashboard', classes: ""}
    ]; // Table headers

    return (
        <div>
            <main className="sl-main sl-mt-8">
                <div className="sl-container sl-m-auto sl-my-8">
                    <h1>Admin Vendor Detail</h1>
                    <AdminTable
                        dataFetched={vendorsFetched}
                        headers={headers}
                        data={vendorsData}
                    />
                </div>
            </main>
        </div>
    );
};

export default AdminVendorDetail;
